exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "upd-moves-summary .tooltip-inner {\n    /* Override .table-responsive styles */\n    white-space: normal;\n  }\n\n.table-responsive {\n  overflow: visible;\n}\n", ""]);

